import { useAppSelector } from 'app/hooks';
import { useEffect, useState } from 'react';
import { isWeatherAlerting } from '../utils/alertCheckers';
import { useDishesByAnalyzer } from 'features/dishes/api/getDishesByAnalyzer';
import { useLocationByAnalyzer } from 'features/locations/api/getLocationByAnalyzer';

export const useIsWeatherAlerting = (analyzerId: number | null | undefined) => {
  const useImperial = useAppSelector(
    (state) => state.auth.user?.us_customary_units
  );
  const { data: dishesForAnalyzer } = useDishesByAnalyzer({
    analyzerId: analyzerId ? analyzerId : -1,
  });
  const { data: locationForAnalyzer } = useLocationByAnalyzer({
    analyzerId: analyzerId ? analyzerId : -1,
  });
  const currentConditions = locationForAnalyzer
    ? locationForAnalyzer.weather
      ? locationForAnalyzer.weather[0]
      : undefined
    : undefined;
  const [weatherAlerting, setWeatherAlerting] = useState<{
    warning: boolean;
    caution: boolean;
  }>({ warning: false, caution: false });
  useEffect(() => {
    if (!dishesForAnalyzer) {
      setWeatherAlerting({ warning: false, caution: false });
      return;
    }
    const alerts = isWeatherAlerting(
      dishesForAnalyzer,
      currentConditions,
      useImperial
    );
    setWeatherAlerting(alerts);
  }, [dishesForAnalyzer, currentConditions, useImperial]);
  return weatherAlerting;
};
